import styled from 'styled-components';

export const ComboProductContainer = styled.div`
  margin-top: 5px;
  .accordion {
    border-radius: 10px !important;
    box-shadow: none !important;
  }
`;
